import { useContent } from './useContent';

export const useLoadingLabel = (isLoading: boolean, labelContentPath: string): string => {
  const { getContentByPath } = useContent();

  if (isLoading) {
    return getContentByPath('loadingCTA.label');
  }

  return getContentByPath(labelContentPath);
};
